<template>
    <div
        v-loading="loading"
        class="location-list"
    >
        <el-table
            :data="preparedData"
            style="width: 100%"
        >
            <el-table-column
                label="Название"
                prop="attributes.title"
                sortable
            >
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.attributes.title }}
                        <i
                            class="el-icon-edit location-list__icon location-list__edit"
                            @click="_tryEdit(scope)"
                        />
                    </div>
                    <div style="font-size: .8em; color: #888;">
                        {{ scope.row.attributes.description }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                :width="120"
                align="center"
            >
                <template slot-scope="scope">
                    <i
                        class="el-icon-delete location-list__icon location-list__remove"
                        @click="_tryRemove(scope)"
                    />
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { Location as LocationApi } from '@/api';
import showError from '@/utils/showError';

export default {
    name: 'LocationList',

    props: {
        search: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            loading: false,
            locations: []
        };
    },

    computed: {
        preparedData() {
            const search = this.search.trim().toLowerCase();

            if (!search) {
                return this.locations;
            }

            return this.locations.filter(location => {
                const title = ((location.attributes && location.attributes.title) || '').toLowerCase();
                const description = ((location.attributes && location.attributes.description) || '').toLowerCase();

                return title.includes(search) || description.includes(search);
            });
        }
    },

    mounted() {
        this.reload();
    },

    methods: {
        reload() {
            this.loading = true;
            LocationApi.list()
                .then(locations => {
                    this.locations = locations;
                })
                .catch(showError('Не удалось получить список мест проведения'))
                .finally(() => {
                    this.loading = false;
                });
        },

        _tryEdit({ row }) {
            this.$emit('edit', { location: row });
        },

        _tryRemove({ row }) {
            this.$confirm('Вы уверены, что хотите удалить место проведения?')
                .then(() => this._remove({ row }))
                .catch(() => {
                });
        },

        _remove({ row }) {
            LocationApi.remove({ locationId: row.id })
                .then(() => {
                    this.$message.success('Место проведения удалено');
                    this.reload();
                })
                .catch(showError('Не удалось удалить место проведения'));
        }
    }
};
</script>

<style lang="scss">
@import "@vars";

.location-list {
    &__icon {
        font-size: 1.2em;
        cursor: pointer;
        visibility: hidden;
    }

    &__edit {
        color: #0486fe;
        margin-left: 10px;
    }

    &__remove {
        color: #eb2929;
    }

    .el-table__row {
        &:hover {
            .location-list__icon {
                visibility: visible;
            }
        }
    }
}
</style>
